import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import './index.css';
import 'pymble-ui/styles.css';
import 'pymble-ui/components.css';
import App from './App';
import { msal as msalConfig } from './config';

export const msalInstance = new PublicClientApplication(msalConfig);

// MSAL v4: initialize() must complete before any MSAL API call.
// MsalProvider v3 also calls initialize() internally, but we do it here
// first so it resolves instantly when MsalProvider calls it again.
// MsalProvider handles handleRedirectPromise() + event callbacks internally.
msalInstance.initialize().then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <App msalInstance={msalInstance} />
    </React.StrictMode>
  );
});
